import "./src/css/style.css"
import "prismjs/themes/prism-coy.css"
